import React from 'react';
import { Link } from 'react-router-dom';

export default function HelpCenter() {
  return (
    <div className="help-page" style={{
      maxWidth: '1000px',
      margin: '20px auto',
      background: '#ffffff',
      borderRadius: '12px',
      padding: '24px',
      boxShadow: '0 2px 12px rgba(0,0,0,0.08)'
    }}>
      <h1 style={{ marginTop: 0 }}>Help Center</h1>

      <p>Welcome to Shopie Bazar Help Center. Find answers to common questions, policies, and how to reach us.</p>

      <section style={{ marginTop: 24 }}>
        <h2>Quick Links</h2>
        <ul>
          <li><Link to="/returns-refunds">Returns & Refunds Policy</Link></li>
          <li><Link to="/privacy">Privacy Policy</Link></li>
          <li><Link to="/terms">Terms of Use</Link></li>
          <li><Link to="/contact">Contact Us</Link></li>
        </ul>
      </section>

      <section style={{ marginTop: 24 }}>
        <h2>Orders & Tracking</h2>
        <p>
          After placing an order, you will receive an email/SMS confirmation. To view your cart or continue checkout, go to the
          {' '}<Link to="/cart">Shopping Cart</Link>.
        </p>
        <p>
          If you need help with a specific order (change address, cancel, or track), contact us at
          {' '}<a href="mailto:support@shopiebazar.com">support@shopiebazar.com</a> with your Order ID.
        </p>
      </section>

      <section style={{ marginTop: 24 }}>
        <h2>Payments</h2>
        <ul>
          <li>We support common online payment methods. Payment details are handled securely by our payment partners.</li>
          <li>If a payment fails, the amount is usually auto-reversed by your bank within 5–7 business days.</li>
        </ul>
      </section>

      <section style={{ marginTop: 24 }}>
        <h2>Shipping & Delivery</h2>
        <ul>
          <li>Orders are typically dispatched within 1–3 business days.</li>
          <li>Delivery timelines vary by location and courier partner.</li>
          <li>If your order is delayed, write to us and we will escalate with the courier.</li>
        </ul>
      </section>

      <section style={{ marginTop: 24 }}>
        <h2>Returns & Refunds</h2>
        <p>
          Not happy with your purchase? Review our full policy here: <Link to="/returns-refunds">Returns & Refunds</Link>.
        </p>
      </section>

      <section style={{ marginTop: 24 }}>
        <h2>Account & Privacy</h2>
        <ul>
          <li>Manage your account details securely within the website.</li>
          <li>Read how we handle your data: <Link to="/privacy">Privacy Policy</Link>.</li>
          <li>To request account deletion, see: <Link to="/data-deletion">Delete Account</Link>.</li>
        </ul>
      </section>

      <section style={{ marginTop: 24 }}>
        <h2>Need more help?</h2>
        <p>
          Email us at <a href="mailto:support@shopiebazar.com">support@shopiebazar.com</a> or call
          {' '}<a href="tel:+911169266020">+91 1169266020</a>. We aim to reply within 24–48 hours.
        </p>
      </section>
    </div>
  );
}
